import logo from "../assets/logo.png";

function EcoLogo({ height = 44 }) {
  return (
    <div style={{
      overflow: "hidden",
      width: "180px",
      height: "50px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <img
        src={logo}
        alt="EcoConnect"
        style={{
          height: "110px",
          width: "260px",
          objectFit: "cover",
          objectPosition: "center",
          mixBlendMode: "multiply",
        }}
      />
    </div>
  );
}

export default EcoLogo;